export enum SocialSignOnProvider {
  SOCIAL_SIGN_ON_PROVIDER_UNKNOWN = 'SOCIAL_SIGN_ON_PROVIDER_UNKNOWN',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE',
  OKTA = 'OKTA',
  FACEBOOK = 'FACEBOOK',
}
